import React from "react";
import { Row, Typography, VertButton, VertModal } from "@vertem-core/vertice-ds";
import { LuCheckCircle } from "react-icons/lu";
import Icon from "components/Atoms/Icons/Icon";

const SuccessModal = ({ closeModal, isOpen, orderId }) => {
    return (
        <VertModal
            open={isOpen}
            onCancel={() => closeModal()}
            onOk={() => closeModal()}
            afterClose={() => closeModal()}
            footer={
                <Row gutter={16} justify="center">
                    <VertButton type="primary" onClick={() => closeModal()}>
                        Ir para Meus Resgates
                    </VertButton>
                </Row>
            }
        >
            <Row gutter={16} justify="center">
                <Icon className='lucide color-success' component={LuCheckCircle} iconStyle="Bold" size="3rem" />
            </Row>
            <Row gutter={16} justify="center" className="margin-top-regular">
                <Typography.Title style={{ textAlign: 'center' }} level={1} className="color-success">
                    {`Solicitação #${orderId} realizada com sucesso`}
                </Typography.Title>
            </Row>
        </VertModal>
    );
}

export default SuccessModal;